<template>
  <div>
    <div v-if="withLoader">
      <button
          :style="btnStyle"
          :class="classes"
      >
        <div v-if="showLoader" class="ld-bg">
          <div class="loader"></div>
        </div>
        <div :class="{ makeVisible: showDoneSign }" class="btn-done-status">
          <svg
              style="fill: #FFF"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
          >
            <path fill="none" d="M0 0h24v24H0V0z" />
            <path
                d="M9 16.17L5.53 12.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41l4.18 4.18c.39.39 1.02.39 1.41 0L20.29 7.71c.39-.39.39-1.02 0-1.41-.39-.39-1.02-.39-1.41 0L9 16.17z"
            />
          </svg>
        </div>
        {{ name }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Button",
  computed: {
    btnStyle() {
      return `position: relative; display: inline-block; height: ${this.height}; padding: ${this.padding}; font-size: ${this.fontSize};`
    }
  },
  props: ["classes", "name", "withLoader", "showLoader", "showDoneSign", "height", "padding", "fontSize"]
}
</script>

<style lang="scss" scoped>
.disableClick {
  pointer-events: none;
  cursor: default;
}
</style>